import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { ethMultiplier } from '../../../constants';

@observer(["CustomWagerStore"])
class StepFour extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };

    }

    render() {
        const { CustomWagerStore } = this.props;
        let endTime = CustomWagerStore.newCustomWager.endTime;
        let reportingEndTime = CustomWagerStore.newCustomWager.reportingEndTime;
        return (
            <div>
                <h1>Confirm Bet Details</h1>
                <div className="custom-bet-modal-confirm-grid">
                    <div className="custom-bet-modal-confirm-grid-cell">
                        <div>Value</div>
                        <span>{(CustomWagerStore.newCustomWager.value/ethMultiplier).toFixed(4)}</span>
                    </div>
                    <div className="custom-bet-modal-confirm-grid-cell">
                        <div>Odds</div>
                        <span>{CustomWagerStore.newCustomWager.odds / 100}</span>
                    </div>
                    <div className="custom-bet-modal-confirm-grid-cell">
                        <div>End Time</div>
                        <span>{new Date(endTime*1000).toLocaleString()}</span>
                    </div>
                    <div className="custom-bet-modal-confirm-grid-cell">
                        <div>Reporting End Time</div>
                        <span>{new Date(reportingEndTime*1000).toLocaleString()}</span>
                    </div>
                    <div className="custom-bet-modal-confirm-grid-cell">
                        <div>Second Outcome</div>
                        <span>{CustomWagerStore.newCustomWager.outcomeOne}</span>
                    </div>
                    <div className="custom-bet-modal-confirm-grid-cell">
                        <div>First Outcome</div>
                        <span>{CustomWagerStore.newCustomWager.outcomeTwo}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default StepFour;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/customBetSteps/StepFour.js